import Marquee, { type MarqueeProps } from "react-fast-marquee";

export default function MyMarquee({
  text,
  ...props
}: { text: string } & MarqueeProps) {
  return (
    <Marquee {...props}>
      <span>{text}</span>
    </Marquee>
  );
}
